import { TelemetryEvent } from '@ms/oteljs';
import { customerContentTenantToken } from './tokenConstants';
import { lazyLogAddinsCustomerContent } from 'owa-analytics';

export async function logCustomerContent(event: TelemetryEvent) {
    const item = getTelemetryItem(event);
    // TODO (sagaikwa) WorkItem: 104192.
    // We may have to update 'item' with more telemetry event data using
    // functions from addOTelColumnData. We may do it here or in caller
    // function sendCustomerContentEvent.
    await lazyLogAddinsCustomerContent.importAndExecute(customerContentTenantToken, item);
}

// A function similar to this will be implemented by Geoffrey.
// That function will return IExtendedTelemetryItem.
// Following dummy function is returning 'any' for simplicity for now.
function getTelemetryItem(event: TelemetryEvent): any {
    let item;
    return item;
}
